// extracted by mini-css-extract-plugin
export var el = "Grid-module--el--1d1cf";
export var elHalf = "Grid-module--el--half--978ba";
export var elMedium = "Grid-module--el--medium--82ddd";
export var elSmall = "Grid-module--el--small--9321b";
export var elSnap = "Grid-module--el--snap--d46cc";
export var gridItem = "Grid-module--gridItem--91861";
export var gridItemCols2 = "Grid-module--gridItem--cols2--d54a2";